/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

const kunnat = [
  { name: "Akaa", x: 61.167145977, y: 23.865888764 },
  { name: "Alajärvi", x: 63.001273254, y: 23.817522812 },
  { name: "Alavieska", x: 64.166646246, y: 24.307213479 },
  { name: "Alavus", x: 62.586161997, y: 23.616600589 },
  { name: "Asikkala", x: 61.172512361, y: 25.549142484 },
  { name: "Askola", x: 60.530210718, y: 25.598880612 },
  { name: "Aura", x: 60.646591846, y: 22.588991955 },
  { name: "Brändö", x: 60.412662338, y: 21.04371379 },
  { name: "Eckerö", x: 60.213612052, y: 19.613138657 },
  { name: "Enonkoski", x: 62.089260323, y: 28.916904602 },
  { name: "Enontekiö", x: 68.385549758, y: 23.635307625 },
  { name: "Espoo", x: 60.206376371, y: 24.656728549 },
  { name: "Eura", x: 61.130003763, y: 22.135931764 },
  { name: "Eurajoki", x: 61.203547237, y: 21.73409618 },
  { name: "Evijärvi", x: 63.36690195, y: 23.47395314 },
  { name: "Finström", x: 60.232262787, y: 19.992383189 },
  { name: "Forssa", x: 60.814791352, y: 23.6164073 },
  { name: "Föglö", x: 60.011288651, y: 20.425481273 },
  { name: "Geta", x: 60.374272036, y: 19.845773869 },
  { name: "Haapajärvi", x: 63.748514012, y: 25.319573489 },
  { name: "Haapavesi", x: 64.136145958, y: 25.364407256 },
  { name: "Hailuoto", x: 65.008596339, y: 24.71112636 },
  { name: "Halsua", x: 63.460145023, y: 24.171590087 },
  { name: "Hamina", x: 60.569688146, y: 27.197900579 },
  { name: "Hammarland", x: 60.218344619, y: 19.73979193 },
  { name: "Hankasalmi", x: 62.390301152, y: 26.436191366 },
  { name: "Hanko", x: 59.82496853, y: 22.966840833 },
  { name: "Harjavalta", x: 61.313701934, y: 22.141199348 },
  { name: "Hartola", x: 61.583533225, y: 26.019445705 },
  { name: "Hattula", x: 61.055937939, y: 24.373688807 },
  { name: "Hausjärvi", x: 60.788352094, y: 25.024743189 },
  { name: "Heinola", x: 61.2052356, y: 26.034841245 },
  { name: "Heinävesi", x: 62.425985285, y: 28.629432602 },
  { name: "Helsinki", x: 60.166640739, y: 24.943536799 },
  { name: "Hirvensalmi", x: 61.643279652, y: 26.77736901 },
  { name: "Hollola", x: 60.988606497, y: 25.512813466 },
  { name: "Honkajoki", x: 61.993243973, y: 22.263525327 },
  { name: "Huittinen", x: 61.177545666, y: 22.699443932 },
  { name: "Humppila", x: 60.922008168, y: 23.367072017 },
  { name: "Hyrynsalmi", x: 64.677259967, y: 28.490705072 },
  { name: "Hyvinkää", x: 60.631016885, y: 24.861124319 },
  { name: "Hämeenkyrö", x: 61.640922455, y: 23.195714863 },
  { name: "Hämeenlinna", x: 60.996174323, y: 24.464424988 },
  { name: "Ii", x: 65.322611335, y: 25.374983789 },
  { name: "Iisalmi", x: 63.559688616, y: 27.186983669 },
  { name: "Iitti", x: 60.890805141, y: 26.33869215 },
  { name: "Ikaalinen", x: 61.768251116, y: 23.074590925 },
  { name: "Ilmajoki", x: 62.733541324, y: 22.577475532 },
  { name: "Ilomantsi", x: 62.672850851, y: 30.92679732 },
  { name: "Imatra", x: 61.171527381, y: 28.769224555 },
  { name: "Inari", x: 68.905469786, y: 27.017602211 },
  { name: "Inkoo", x: 60.044664081, y: 24.006574663 },
  { name: "Isojoki", x: 62.115137142, y: 21.958478468 },
  { name: "Isokyrö", x: 63.000103009, y: 22.318211434 },
  { name: "Janakkala", x: 60.921846055, y: 24.647706584 },
  { name: "Joensuu", x: 62.602079226, y: 29.759679275 },
  { name: "Jokioinen", x: 60.805162808, y: 23.490085206 },
  { name: "Jomala", x: 60.15043419, y: 19.95256632 },
  { name: "Joroinen", x: 62.179506084, y: 27.826421809 },
  { name: "Joutsa", x: 61.74027126, y: 26.110981259 },
  { name: "Juuka", x: 63.239859772, y: 29.254325823 },
  { name: "Juupajoki", x: 61.797913262, y: 24.369974148 },
  { name: "Juva", x: 61.897472595, y: 27.857335654 },
  { name: "Jyväskylä", x: 62.241677684, y: 25.749498121 },
  { name: "Jämijärvi", x: 61.820221688, y: 22.691024601 },
  { name: "Jämsä", x: 61.864256654, y: 25.190231473 },
  { name: "Järvenpää", x: 60.481098394, y: 25.10074741 },
  { name: "Kaarina", x: 60.407620851, y: 22.371004907 },
  { name: "Kaavi", x: 62.974976715, y: 28.480838102 },
  { name: "Kajaani", x: 64.226733925, y: 27.728046683 },
  { name: "Kalajoki", x: 64.260430362, y: 23.949156078 },
  { name: "Kangasala", x: 61.463200572, y: 24.067165047 },
  { name: "Kangasniemi", x: 61.988644474, y: 26.642473064 },
  { name: "Kankaanpää", x: 61.803357693, y: 22.39516256 },
  { name: "Kannonkoski", x: 62.976573477, y: 25.263430615 },
  { name: "Kannus", x: 63.901745411, y: 23.915054223 },
  { name: "Karijoki", x: 62.308417557, y: 21.704898532 },
  { name: "Karkkila", x: 60.534934578, y: 24.20821133 },
  { name: "Karstula", x: 62.876603857, y: 24.800504818 },
  { name: "Karvia", x: 62.138536127, y: 22.562560142 },
  { name: "Kaskinen", x: 62.382871885, y: 21.225392339 },
  { name: "Kauhajoki", x: 62.425088156, y: 22.177243878 },
  { name: "Kauhava", x: 63.100920012, y: 23.065244367 },
  { name: "Kauniainen", x: 60.210640465, y: 24.7277527 },
  { name: "Kaustinen", x: 63.548090648, y: 23.69987851 },
  { name: "Keitele", x: 63.179589177, y: 26.349949125 },
  { name: "Kemi", x: 65.733635445, y: 24.56341556 },
  { name: "Kemijärvi", x: 66.715018519, y: 27.430577528 },
  { name: "Keminmaa", x: 65.798981364, y: 24.54262919 },
  { name: "Kemiönsaari", x: 60.163845255, y: 22.728934263 },
  { name: "Kempele", x: 64.912672171, y: 25.50995188 },
  { name: "Kerava", x: 60.404868786, y: 25.103548718 },
  { name: "Keuruu", x: 62.260208877, y: 24.706448341 },
  { name: "Kihniö", x: 62.203176316, y: 23.177811003 },
  { name: "Kinnula", x: 63.367271175, y: 24.9699576 },
  { name: "Kirkkonummi", x: 60.12065796, y: 24.438913078 },
  { name: "Kitee", x: 62.096690509, y: 30.145386285 },
  { name: "Kittilä", x: 67.653127857, y: 24.911437456 },
  { name: "Kiuruvesi", x: 63.651462106, y: 26.622489907 },
  { name: "Kivijärvi", x: 63.12292486, y: 25.070968069 },
  { name: "Kokemäki", x: 61.256136349, y: 22.350459185 },
  { name: "Kokkola", x: 63.837583062, y: 23.131961664 },
  { name: "Kolari", x: 67.331718287, y: 23.788974026 },
  { name: "Konnevesi", x: 62.627334113, y: 26.289457254 },
  { name: "Kontiolahti", x: 62.766465365, y: 29.844407795 },
  { name: "Korsnäs", x: 62.785052299, y: 21.188728029 },
  { name: "Koski Tl", x: 60.652981939, y: 23.137367393 },
  { name: "Kotka", x: 60.465520795, y: 26.941152634 },
  { name: "Kouvola", x: 60.866825214, y: 26.705598153 },
  { name: "Kristiinankaupunki", x: 62.274742151, y: 21.37854708 },
  { name: "Kruunupyy", x: 63.727817733, y: 23.033771859 },
  { name: "Kuhmo", x: 64.125288629, y: 29.524367548 },
  { name: "Kuhmoinen", x: 61.562425983, y: 25.175665612 },
  { name: "Kumlinge", x: 60.259692477, y: 20.778313171 },
  { name: "Kuopio", x: 62.892982923, y: 27.688934744 },
  { name: "Kuortane", x: 62.807410615, y: 23.506393077 },
  { name: "Kurikka", x: 62.618893949, y: 22.39877371 },
  { name: "Kustavi", x: 60.546714695, y: 21.358881644 },
  { name: "Kuusamo", x: 65.964424921, y: 29.18861606 },
  { name: "Kyyjärvi", x: 63.043410994, y: 24.566437311 },
  { name: "Kärkölä", x: 60.86837648, y: 25.273377105 },
  { name: "Kärsämäki", x: 63.980587073, y: 25.759667454 },
  { name: "Kökar", x: 59.920278312, y: 20.908372757 },
  { name: "Lahti", x: 60.980380564, y: 25.654987962 },
  { name: "Laihia", x: 62.977956713, y: 22.011173105 },
  { name: "Laitila", x: 60.875860346, y: 21.690233379 },
  { name: "Lapinjärvi", x: 60.624363429, y: 26.201405459 },
  { name: "Lapinlahti", x: 63.364517752, y: 27.387415475 },
  { name: "Lappajärvi", x: 63.217602823, y: 23.632849978 },
  { name: "Lappeenranta", x: 61.058749724, y: 28.187689913 },
  { name: "Lapua", x: 62.970168655, y: 23.007570333 },
  { name: "Laukaa", x: 62.413528005, y: 25.957777304 },
  { name: "Lemi", x: 61.061522998, y: 27.804960542 },
  { name: "Lemland", x: 60.068453521, y: 20.099599382 },
  { name: "Lempäälä", x: 61.312525626, y: 23.755748116 },
  { name: "Leppävirta", x: 62.491829038, y: 27.788663006 },
  { name: "Lestijärvi", x: 63.524801746, y: 24.66580332 },
  { name: "Lieksa", x: 63.317804542, y: 30.028096821 },
  { name: "Lieto", x: 60.506876265, y: 22.455932813 },
  { name: "Liminka", x: 64.809794749, y: 25.411946267 },
  { name: "Liperi", x: 62.534480932, y: 29.367861963 },
  { name: "Lohja", x: 60.250916253, y: 24.065782053 },
  { name: "Loimaa", x: 60.851362252, y: 23.058593858 },
  { name: "Loppi", x: 60.717556416, y: 24.44356627 },
  { name: "Loviisa", x: 60.457732981, y: 26.223660363 },
  { name: "Luhanka", x: 61.796805591, y: 25.703825319 },
  { name: "Lumijoki", x: 64.837617135, y: 25.187125981 },
  { name: "Lumparland", x: 60.1174024, y: 20.258892131 },
  { name: "Luoto", x: 63.755494342, y: 22.746684981 },
  { name: "Luumäki", x: 60.92092464, y: 27.559740129 },
  { name: "Maalahti", x: 62.942910055, y: 21.552851475 },
  { name: "Maarianhamina", x: 60.101520836, y: 19.942267834 },
  { name: "Marttila", x: 60.585411972, y: 22.898967272 },
  { name: "Masku", x: 60.570991977, y: 22.098688118 },
  { name: "Merijärvi", x: 64.29771802, y: 24.441848134 },
  { name: "Merikarvia", x: 61.86033969, y: 21.505430059 },
  { name: "Miehikkälä", x: 60.669224483, y: 27.696366399 },
  { name: "Mikkeli", x: 61.687726895, y: 27.273224374 },
  { name: "Muhos", x: 64.808918576, y: 25.990050022 },
  { name: "Multia", x: 62.408697501, y: 24.794621331 },
  { name: "Muonio", x: 67.959275326, y: 23.677223262 },
  { name: "Mustasaari", x: 63.114054101, y: 21.680745161 },
  { name: "Muurame", x: 62.13050888, y: 25.67356508 },
  { name: "Mynämäki", x: 60.678732788, y: 21.987506589 },
  { name: "Myrskylä", x: 60.670439657, y: 25.852102173 },
  { name: "Mäntsälä", x: 60.63608498, y: 25.320204692 },
  { name: "Mänttä-Vilppula", x: 62.036948707, y: 24.553095512 },
  { name: "Mäntyharju", x: 61.41828094, y: 26.875355649 },
  { name: "Naantali", x: 60.467709253, y: 22.018224718 },
  { name: "Nakkila", x: 61.366902193, y: 22.004075891 },
  { name: "Nivala", x: 63.929637787, y: 24.953943761 },
  { name: "Nokia", x: 61.478773769, y: 23.508499404 },
  { name: "Nousiainen", x: 60.599114832, y: 22.082180366 },
  { name: "Nurmes", x: 63.544266312, y: 29.132995571 },
  { name: "Nurmijärvi", x: 60.460806119, y: 24.807369231 },
  { name: "Närpiö", x: 62.473293481, y: 21.336718308 },
  { name: "Orimattila", x: 60.80402214, y: 25.734288563 },
  { name: "Oripää", x: 60.856350309, y: 22.697411262 },
  { name: "Orivesi", x: 61.677407146, y: 24.357389414 },
  { name: "Oulainen", x: 64.266570168, y: 24.816231983 },
  { name: "Oulu", x: 65.013784817, y: 25.47209907 },
  { name: "Outokumpu", x: 62.726024464, y: 29.015423401 },
  { name: "Padasjoki", x: 61.351408456, y: 25.277610756 },
  { name: "Paimio", x: 60.455410664, y: 22.691146855 },
  { name: "Paltamo", x: 64.409447258, y: 27.832162935 },
  { name: "Parainen", x: 60.299124907, y: 22.3023017 },
  { name: "Parikkala", x: 61.55512963, y: 29.501065813 },
  { name: "Parkano", x: 62.010623403, y: 23.021041049 },
  { name: "Pedersören kunta", x: 63.601233473, y: 22.791289301 },
  { name: "Pelkosenniemi", x: 67.109192048, y: 27.512878531 },
  { name: "Pello", x: 66.775583504, y: 23.96347775 },
  { name: "Perho", x: 63.215274507, y: 24.423163042 },
  { name: "Pertunmaa", x: 61.503094056, y: 26.477987839 },
  { name: "Petäjävesi", x: 62.256663764, y: 25.183606514 },
  { name: "Pieksämäki", x: 62.298590826, y: 27.155481907 },
  { name: "Pielavesi", x: 63.232348566, y: 26.755606074 },
  { name: "Pietarsaari", x: 63.675221726, y: 22.702931738 },
  { name: "Pihtipudas", x: 63.370334395, y: 25.574614233 },
  { name: "Pirkkala", x: 61.465248956, y: 23.645483231 },
  { name: "Polvijärvi", x: 62.856826994, y: 29.369602563 },
  { name: "Pomarkku", x: 61.694846754, y: 22.010453708 },
  { name: "Pori", x: 61.483726303, y: 21.795900114 },
  { name: "Pornainen", x: 60.47689845, y: 25.372932372 },
  { name: "Porvoo", x: 60.395371935, y: 25.666559544 },
  { name: "Posio", x: 66.109736985, y: 28.173906419 },
  { name: "Pudasjärvi", x: 65.36094712, y: 26.999243541 },
  { name: "Pukkila", x: 60.645352853, y: 25.580407556 },
  { name: "Punkalaidun", x: 61.113272934, y: 23.100542189 },
  { name: "Puolanka", x: 64.868658767, y: 27.669071121 },
  { name: "Puumala", x: 61.521855331, y: 28.179971761 },
  { name: "Pyhtää", x: 60.492210487, y: 26.544880023 },
  { name: "Pyhäjoki", x: 64.465163558, y: 24.259197182 },
  { name: "Pyhäjärvi", x: 63.681835448, y: 25.985775658 },
  { name: "Pyhäntä", x: 64.099460341, y: 26.329977857 },
  { name: "Pyhäranta", x: 60.948266485, y: 21.440934529 },
  { name: "Pälkäne", x: 61.336821181, y: 24.270409233 },
  { name: "Pöytyä", x: 60.721369364, y: 22.599537679 },
  { name: "Raahe", x: 64.687734335, y: 24.478273101 },
  { name: "Raasepori", x: 59.974552922, y: 23.43622808 },
  { name: "Raisio", x: 60.486079651, y: 22.171068833 },
  { name: "Rantasalmi", x: 62.063413397, y: 28.304229966 },
  { name: "Ranua", x: 65.927505623, y: 26.518416699 },
  { name: "Rauma", x: 61.128737875, y: 21.511126919 },
  { name: "Rautalampi", x: 62.621137137, y: 26.835420999 },
  { name: "Rautavaara", x: 63.494210301, y: 28.298223078 },
  { name: "Rautjärvi", x: 61.433471798, y: 29.36791525 },
  { name: "Reisjärvi", x: 63.604386795, y: 24.937851054 },
  { name: "Riihimäki", x: 60.736737225, y: 24.775321449 },
  { name: "Ristijärvi", x: 64.505096191, y: 28.211768863 },
  { name: "Rovaniemi", x: 66.502790259, y: 25.728478856 },
  { name: "Ruokolahti", x: 61.292264125, y: 28.815799538 },
  { name: "Ruovesi", x: 61.984488222, y: 24.068811837 },
  { name: "Rusko", x: 60.542439512, y: 22.222515059 },
  { name: "Rääkkylä", x: 62.312677024, y: 29.626058461 },
  { name: "Saarijärvi", x: 62.705523683, y: 25.253902 },
  { name: "Salla", x: 66.830971278, y: 28.669933096 },
  { name: "Salo", x: 60.384373601, y: 23.126727127 },
  { name: "Saltvik", x: 60.275214843, y: 20.059115249 },
  { name: "Sastamala", x: 61.340225146, y: 22.906437534 },
  { name: "Sauvo", x: 60.344506715, y: 22.691750338 },
  { name: "Savitaipale", x: 61.198742149, y: 27.686019135 },
  { name: "Savonlinna", x: 61.869802657, y: 28.87849829 },
  { name: "Savukoski", x: 67.292004821, y: 28.164370823 },
  { name: "Seinäjoki", x: 62.786662897, y: 22.842279603 },
  { name: "Sievi", x: 63.906281167, y: 24.521156852 },
  { name: "Siikainen", x: 61.877660372, y: 21.823140984 },
  { name: "Siikajoki", x: 64.663838767, y: 25.103293299 },
  { name: "Siikalatva", x: 64.27203017, y: 25.863775714 },
  { name: "Siilinjärvi", x: 63.073664705, y: 27.659698525 },
  { name: "Simo", x: 65.661270047, y: 25.062297166 },
  { name: "Sipoo", x: 60.376856973, y: 25.268516114 },
  { name: "Siuntio", x: 60.138017546, y: 24.224863347 },
  { name: "Sodankylä", x: 67.414920225, y: 26.590673697 },
  { name: "Soini", x: 62.87297229, y: 24.210173232 },
  { name: "Somero", x: 60.628290724, y: 23.517691265 },
  { name: "Sonkajärvi", x: 63.669163025, y: 27.523742906 },
  { name: "Sotkamo", x: 64.13202497, y: 28.387689851 },
  { name: "Sottunga", x: 60.1299875, y: 20.667418704 },
  { name: "Sulkava", x: 61.789726328, y: 28.378042315 },
  { name: "Sund", x: 60.250200171, y: 20.116293532 },
  { name: "Suomussalmi", x: 64.883821118, y: 28.904794739 },
  { name: "Suonenjoki", x: 62.623037446, y: 27.127576934 },
  { name: "Sysmä", x: 61.503771936, y: 25.68370291 },
  { name: "Säkylä", x: 61.048361211, y: 22.336785897 },
  { name: "Taipalsaari", x: 61.161330352, y: 28.057579346 },
  { name: "Taivalkoski", x: 65.576252124, y: 28.240598067 },
  { name: "Taivassalo", x: 60.561807633, y: 21.611197663 },
  { name: "Tammela", x: 60.808134311, y: 23.760277513 },
  { name: "Tampere", x: 61.49774257, y: 23.761290078 },
  { name: "Tervo", x: 62.95214524, y: 26.753932331 },
  { name: "Tervola", x: 66.087024017, y: 24.81106439 },
  { name: "Teuva", x: 62.484761491, y: 21.747190967 },
  { name: "Tohmajärvi", x: 62.226235418, y: 30.333057263 },
  { name: "Toholampi", x: 63.771687856, y: 24.250504148 },
  { name: "Toivakka", x: 62.097929789, y: 26.082544741 },
  { name: "Tornio", x: 65.84973018, y: 24.144091609 },
  { name: "Turku", x: 60.451690351, y: 22.266866666 },
  { name: "Tuusniemi", x: 62.812406598, y: 28.488250625 },
  { name: "Tuusula", x: 60.402369377, y: 25.025142036 },
  { name: "Tyrnävä", x: 64.763363971, y: 25.652633446 },
  { name: "Ulvila", x: 61.432652934, y: 21.888033305 },
  { name: "Urjala", x: 61.081131717, y: 23.549311266 },
  { name: "Utajärvi", x: 64.76169558, y: 26.416907969 },
  { name: "Utsjoki", x: 69.907828523, y: 27.026541275 },
  { name: "Uurainen", x: 62.50080639, y: 25.438518873 },
  { name: "Uusikaarlepyy", x: 63.523125804, y: 22.530086009 },
  { name: "Uusikaupunki", x: 60.801207736, y: 21.407727115 },
  { name: "Vaala", x: 64.560942154, y: 26.840673725 },
  { name: "Vaasa", x: 63.092588875, y: 21.615874122 },
  { name: "Valkeakoski", x: 61.270053249, y: 24.029248502 },
  { name: "Valtimo", x: 63.680306323, y: 28.813705084 },
  { name: "Vantaa", x: 60.298133721, y: 25.006641332 },
  { name: "Varkaus", x: 62.313950665, y: 27.888587335 },
  { name: "Vehmaa", x: 60.685902746, y: 21.712512133 },
  { name: "Vesanto", x: 62.93103044, y: 26.412849105 },
  { name: "Vesilahti", x: 61.305583862, y: 23.627636445 },
  { name: "Veteli", x: 63.475287314, y: 23.78862512 },
  { name: "Vieremä", x: 63.744069514, y: 27.005160452 },
  { name: "Vihti", x: 60.416791924, y: 24.319858395 },
  { name: "Viitasaari", x: 63.082792009, y: 25.855167908 },
  { name: "Vimpeli", x: 63.161927977, y: 23.820600738 },
  { name: "Virolahti", x: 60.582071101, y: 27.708871595 },
  { name: "Virrat", x: 62.23848456, y: 23.773747693 },
  { name: "Vårdö", x: 60.244351018, y: 20.375338092 },
  { name: "Vöyri", x: 63.132068002, y: 22.252456379 },
  { name: "Ylitornio", x: 66.323044983, y: 23.673012317 },
  { name: "Ylivieska", x: 64.072284496, y: 24.533690188 },
  { name: "Ylöjärvi", x: 61.55715602, y: 23.596580124 },
  { name: "Ypäjä", x: 60.805227741, y: 23.272438379 },
  { name: "Ähtäri", x: 62.55285929, y: 24.075018434 },
  { name: "Äänekoski", x: 62.603307432, y: 25.72483135 },
];

export default kunnat;
